import { CONFIG } from '../../config'
import { MOMENT_TIME } from '../../momenttime'
var timeArr = MOMENT_TIME.getTimeArrayByTimeStamp().splice(0, 4),
    timeStr = timeArr.join('');

var DISCUSS_DATA_MANAGER = {
    /**
     * 获取新建论盘的名称
     * @returns '微信论盘_20191205'
     */
    getNewLunPanTitle() {
        // var startStr = detailInfo.f_name.length > 5 ? detailInfo.f_name.slice(0, 5) : detailInfo.f_name;
        var startStr = '';
        if(CONFIG.platform == 'qq') { startStr = 'QQ论盘_' };
        if(CONFIG.platform == 'wechat') { startStr = '微信论盘_' };
        var date = MOMENT_TIME.getFormateTimeYMDHmByTimeStamp();
        date = date.replace(/-/gi, '');
        date = date.replace(/:/gi, '');
        date = date.replace(/\s+/g, '');
        return startStr + date;
    },

    /**
     * 根据服务器返回的论盘数据获得前端展示的论盘数据结构体
     * @param {服务器返回论盘数据} data 
     */
    getLunPanDataByData(data) {
        var createTime = '';
        if(data.f_time) {
            createTime = MOMENT_TIME.getFormateTimeYMDByTimeStamp(data.f_time * 1000);
            createTime = createTime.replace('-', '年');
            createTime = createTime.replace('-', '月');
            createTime = createTime + '日';
        }
        var lunpanData = {
            id: data.id,
            hid: data.hid,
            rid: data.rid,
            isEnd: data.isEnd,
            title: data.f_title,
            shareCode: data.share,
            createTime: createTime
        }
        return lunpanData;
    },

    /**
     * 根据修改数据的参数更新原始论盘列表数据
     * @param {原始数据} origiList 
     * @param {修改后的数据包含id和修改的内容} newData 
     */
    updateLunPanListDataTitle(origiList, newData) {
        origiList.forEach(data => {
            if(data.id == newData.id) {
                data.title = newData.f_title;
            }
        });
        return origiList;
    },

    /**
     * 根据删除数据的id删除本地数据
     * @param {原始数据} origiList 
     * @param {删除数据的id} deleteId 
     */
    deleteLunPanListData(origiList, deleteId) {
        origiList.forEach((data, index) => {
            if(data.id == deleteId) {
                origiList.splice(index, 1);
            }
        });
        return origiList;
    },

    /**
     * 根据服务器返回聊天数据获取前端聊天数据结构体
     * @param {服务器返回数据} data 
     * {"type":"say","msg_type":1,"content":"234657987","time":1575851457,"userInfo":{"uid":"101238","nickname":"科达"},"id":"289110"}
     */
    getHistoryListDataByData(data) {
        var resultData = {};
        //根据数据类型:1文本,2图片,3语音
        switch(data.msg_type) {
            case 1:
                resultData = {
                    type: 'text',
                    id: data.id,
                    content: data.content,
                    time: data.time,
                    uid: data.userInfo.uid,
                    nickname: data.userInfo.nickname,
                    avatarUrl: 'https://api.yxdxt.com/profile/?id=' + data.userInfo.uid +'&v=' + timeStr,
                }
                break;
            case 2:
                break;
            case 3:
                break;
            default:
                break;
        }
        return resultData;
    },
    
    /**
     * 根据前端返回到我的聊天数据获取前端聊天数据结构体
     * @param {服务器返回数据} data 
     * {uid: this.curUserUid, msg_type:1, content:"234657987"}
     */
    getHistoryListDataByMyData(data) {
        var resultData = {};
        //根据数据类型:1文本,2图片,3语音
        switch(data.msg_type) {
            case 1:
                resultData = {
                    type: 'text',
                    content: data.content,
                    time: MOMENT_TIME.getTimeStampByNow(),
                    uid: data.uid,
                    nickname: '',
                    avatarUrl: 'https://api.yxdxt.com/profile/?id=' + data.uid +'&v=' + timeStr,
                }
                break;
            case 2:
                break;
            case 3:
                break;
            default:
                break;
        }
        return resultData;
    },

    /**
     * 根据服务器返回聊天列表数据获取前端聊天数据结构体
     * @param {服务器返回列表数据}} data 
     */
    getHistoryListDataByListData(data) {
        var resultData = {};
        //根据数据类型:1文本,2图片,3语音
        switch(data.f_type) {
            case 1:
                resultData = {
                    type: 'text',
                    id: data.id,
                    content: data.content,
                    time: data.f_time,
                    uid: data.userInfo.uid,
                    nickname: data.userInfo.nickname,
                    avatarUrl: 'https://api.yxdxt.com/profile/?id=' + data.userInfo.uid +'&v=' + timeStr,
                }
                break;
            case 2:
                break;
            case 3:
                break;
            default:
                break;
        }
        return resultData;
    },

    /**
     * 根据服务器返回列表数据获取客户端聊天记录列表数据
     * @param {原始列表数据} origiList 
     * @param {服务器返回列表数据} list 
     */
    initHistoryListDataByList(origiList, list) {
        var me = this, resultList = [], newestId = 0;
        list.forEach((data, index) => {
            var newData = me.getHistoryListDataByListData(data);
            resultList.push(newData);
            newestId = (index == list.length - 1) ? data.id : newestId;
        });
        origiList = origiList.concat(resultList);
        origiList.sort((a, b) => {return a.time - b.time});
        return {
            resultList: origiList,
            newestId: newestId
        };
    },

    /**
     * 根据WS接收到的数据来更新当前聊天记录列表数据
     * @param {原始列表数据} origiList 
     * @param {新接收到的数据} newData 
     */
    addHistoryListDataByData(origiList, newData) {
        var addData = this.getHistoryListDataByData(newData);
        // console.log('addHistoryListDataByData-----', origiList, addData, newData)
        origiList.push(addData);
        origiList.sort((a, b) => {return a.time - b.time});
        return origiList;
    },

    addHistoryListDataByMyData(origiList, myData) {
        var addData = this.getHistoryListDataByMyData(myData);
        // console.log('addHistoryListDataByData-----', origiList, addData, myData)
        origiList.push(addData);
        origiList.sort((a, b) => {return a.time - b.time});
        return origiList;
    }

}

export {
    DISCUSS_DATA_MANAGER
}